import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import authModule from "../../../../../../../utilities/AuthModule";
import { IGraphInsightsItem, InsightType } from "./api-graph-interfaces";

const GRAPH_API_URL = 'https://graph.microsoft.com/v1.0';

export const apiGraphInsightsSlice = createApi({
    reducerPath: 'api-graph-insights',
    baseQuery: retry(fetchBaseQuery({
        baseUrl: GRAPH_API_URL,
        prepareHeaders: async (headers) => {
            const accessToken = await authModule.getGraphAccessToken();
            headers.set('Authorization', `Bearer ${accessToken}`);
            return headers;
        },
    })),
    endpoints: (builder) => ({
        getItemsTrendingAroundMe: builder.query<IGraphInsightsItem[], void>({
            query: () => {
                return {
                    url: `/me/insights/trending`,
                    method: 'GET'
                }
            },
            transformResponse: (response: any) => {
                return (response.value as IGraphInsightsItem[]).map(val => {
                    return {
                        ...val,
                        insightType: InsightType.Trending
                    }
                });
            },
        }),
        getItemsSharedWithMe: builder.query<IGraphInsightsItem[], void>({
            query: () => {
                return {
                    url: `/me/insights/shared`,
                    method: 'GET'
                }
            },
            transformResponse: (response: any) => {
                return (response.value as IGraphInsightsItem[]).filter(x => x.resourceVisualization.title).map(val => {
                    return {
                        ...val,
                        insightType: InsightType.Shared,
                        gridDate: new Date(val.lastShared.sharedDateTime)
                    }
                });
            },
        }),
        getItemsViewedAndModifiedByMe: builder.query<IGraphInsightsItem[], void>({
            query: () => {
                return {
                    url: `/me/insights/used`,
                    method: 'GET'
                }
            },
            transformResponse: (response: any) => {
                return (response.value as IGraphInsightsItem[]).map(val => {
                    return {
                        ...val,
                        insightType: InsightType.Recent,
                        gridDate: new Date(val.lastUsed.lastModifiedDateTime)
                    }
                });
            },
        }),
        getFileThumbnail: builder.query<any, { itemDriveId: string }>({
            query: (args) => {
                return {
                    url: `/${args.itemDriveId}/thumbnails?$select=large`,
                    method: 'GET'
                }
            }
        }),
    })
});

export const {
    useLazyGetItemsTrendingAroundMeQuery,
    useLazyGetItemsSharedWithMeQuery,
    useLazyGetItemsViewedAndModifiedByMeQuery,
    useLazyGetFileThumbnailQuery
} = apiGraphInsightsSlice;